export function getTableLoaderListApiParams(params) {
  return params
}
